// extracted by mini-css-extract-plugin
export default {"imageContainer":"Lfa-z","summaryPar":"Mfa-z","ratingCategories":"Nfa-z","reviewerInfo":"Ofa-z","reviewTypes":"Pfa-z","expanded":"Qfa-z"};